<!--师资培训菜单-->
<template>
    <div class="menu-container">
<!--        <div @click="changeItem('1')" :class="activeItem==='1'?'menu-item menu-active':'menu-item'">培训统计</div>-->
        <div @click="changeItem('2')" :class="activeItem==='2'?'menu-item menu-active':'menu-item'">培训任务</div>
        <div @click="changeItem('3')" :class="activeItem==='3'?'menu-item menu-active':'menu-item'">培训课程</div>
    </div>
</template>

<script>

export default {
    name:'teaTrainMenu',
    components:{},
    props:{
        itemNum:{
            type: String,
            default:"1"
        },
        studioNature:{
            type: String,
            default:"2"
        },
    },
    watch:{
        itemNum(newValue,oldValue){
            this.activeItem = newValue;
        },
    },
    mounted() {},
    data() {
        return {
            activeItem:"2",
        }
    },
    methods: {
        changeItem(item){
            this.activeItem = item;
            this.$emit('change-item', item );
        },
    }
}

</script>

<style scoped>
.menu-container{
    display: inline-flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
}
.menu-item{
    height: 38px;
    line-height: 38px;
    padding: 0 22px;
    box-sizing: border-box;
    text-align: center;
    font-size: 16px;
    color: #ff7f2e;
    background: #fff;
    border: 1px solid #ff7f2e;
    border-radius: 19px;
    cursor: pointer;
    white-space: nowrap;
}
.menu-active{
    background: #ff7f2e;
    border-color: #ff7f2e;
    color: #fff;
}
</style>